import { ErrorMessage } from "formik"
import React, { Component } from "react"
import styled from "styled-components"

const FieldError = styled(ErrorMessage)`
  color: red;
  font-size: 10px;
  margin-bottom: 10px;
  margin-top: 0;
`

const StyledTextarea = styled.textarea`
  -webkit-appearance: none;
  border: 1px solid ${props => props.theme.colors.grey[10]};
  border-radius: 0;
  color: ${props => props.theme.colors.black};
  font-size: 14px;
  line-height: 1.2;
  margin-bottom: 15px;
  max-width: 100%;
  padding: 10px;
  transition: all 200ms ease;
  width: 100%;
  :focus {
    outline: none;
    border-color: ${props => props.theme.colors.black};
  }
  ::placeholder {
    color: ${props => props.theme.colors.grey[35]};
  }
  :disabled {
    -webkit-text-fill-color: ${props => props.theme.colors.grey[30]};
    color: ${props => props.theme.colors.grey[30]};
    opacity: 1;
  }
`

class Textarea extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <>
        <StyledTextarea {...this.props} />
        {this.props.name && <FieldError name={this.props.name} component="p" />}
      </>
    )
  }
}

export default Textarea
